const ip_blacklist = {
	deblock_dialog: {
		description:
			"Sind Sie sicher, dass Sie die IP-Adresse <strong>{{ip_address}}</strong> freigeben möchten?",
		title: "IP-Adresse freigeben",
	},
	on_success: "IP-Adresse erfolgreich freigegeben",
	table: {
		created_at: "Blockiert am",
		failures: "Fehlgeschlagene Anmeldeversuche",
		id: "ID",
		ip_address: "IP-Adresse",
		no_items: "Keine Einträge gefunden",
		username: "Benutzername",
	},
	title: "IP-Sperrliste",
};

export default ip_blacklist;
